import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import { SLOTS_APIS } from "@/api_framework/api_config";

AxiosCurlirize(axios, () => { });

// Request body
interface IShiftedBookingsCountFilters {
    city_id?: string[];
    clinic_id?: string[];
    service_id?: string[];
    subservice_id?: string[];
    date?: string;
    from_date?: string;
    to_date?: string;
    time?: number;
}

// Response type (adjust if backend differs)
interface IShiftedBookingsCountResponse {
    status: boolean;
    data: {
        today_count?: number;
        yesterday_count?: number;
        tomorrow_count?: number;
        day_after_tomorrow_count?: number;
        day_after_after_tomorrow_count?: number;
    };
    message?: string;
}

export const useShiftedBookingsCountAPI = () => {
    const configuration = useConfiguration();
    const { sendCurl } = useCurlLogger();
    const [countData, setCountData] = useState<IShiftedBookingsCountResponse["data"] | null>(null);

    const execute = useCallback(
        async (filters: IShiftedBookingsCountFilters) => {
            try {
                const accessToken = localStorage.getItem(
                    configuration.localStorage.ACCESS_TOKEN.key
                );

                const res: AxiosResponse<IShiftedBookingsCountResponse> =
                    await axios.post(
                        SLOTS_APIS?.SHIFT_APPOINTMENT_COUNT?.baseURL,
                        filters,
                        {
                            headers: {
                                Authorization: `${accessToken}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );

                if (res.data?.status) {
                    setCountData(res.data.data);
                    console.log("Shifted Bookings Count:", res.data.data);
                }

            } catch (error) {
                const e = error as AxiosError;

                if (e.config?.["curlCommand"]) {
                    sendCurl(e.config["curlCommand"]);
                }

                if (e.response?.status === 400) {
                    toast.error("Invalid request");
                } else {
                    toast.error("Something went wrong");
                }

                console.error("Shifted Bookings Count Error:", e.message);
            }
        },
        [configuration, sendCurl]
    );

    return { execute, countData };
};
